// ── BarChartCard ──────────────────────────────────────────────────────────────

export const barChartCenteredBoxSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as const;

export const barChartGridStroke = '#e0e0e0';
export const barChartAxisTickStyle = { fontSize: 11, fill: '#888' };
export const barChartTooltipCursorSx = { fill: 'rgba(0,0,0,0.04)' };
export const barChartDollarLabelStyle = { fill: '#fff', fontSize: 13, fontWeight: 700 };

// ── ChartTooltip ──────────────────────────────────────────────────────────────

export const tooltipContainerSx = {
  bgcolor: '#fff',
  color: '#1a1a2e',
  borderRadius: 1.5,
  px: 1.5,
  py: 1,
  minWidth: 240,
  maxWidth: 320,
  fontSize: 12,
  boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
  border: '1px solid rgba(0,0,0,0.07)',
} as const;

export const tooltipHeaderSx = {
  display: 'flex',
  justifyContent: 'space-between',
  mb: 0.75,
} as const;

export const tooltipHeaderTextSx = { fontSize: 12, fontWeight: 600, color: '#1a1a2e' } as const;

export const tooltipRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  mb: 0.4,
} as const;

export const tooltipDotSx = (color: string) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  bgcolor: color,
  flexShrink: 0,
});

export const tooltipLabelSx = {
  fontSize: 11,
  color: '#555',
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export const tooltipDurationSx = { fontSize: 11, color: '#1a1a2e', ml: 1, flexShrink: 0 } as const;
export const tooltipPercentageSx = { fontSize: 11, color: '#888', ml: 0.5, flexShrink: 0 } as const;
export const tooltipOverflowSx = { fontSize: 10, color: '#aaa', mt: 0.5, fontStyle: 'italic' } as const;

// ── ChartDetailModal ──────────────────────────────────────────────────────────

export const modalTitleSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  pb: 1,
} as const;

export const modalTotalRowSx = {
  display: 'flex',
  justifyContent: 'space-between',
  mb: 1.5,
} as const;

export const modalRowSx = (isLast: boolean) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  py: 0.75,
  borderBottom: isLast ? 'none' : '1px solid',
  borderColor: 'divider',
});

export const modalDotSx = (color: string) => ({
  width: 10,
  height: 10,
  borderRadius: '50%',
  bgcolor: color,
  flexShrink: 0,
});

export const modalPercentageSx = {
  fontSize: 13,
  color: 'text.secondary',
  ml: 1,
  flexShrink: 0,
  minWidth: 48,
  textAlign: 'right' as const,
} as const;
